import {useQuery} from '@tanstack/react-query';
import {apiService} from "../utils/serviceApi";

// Define activity types as constants
export const GasStationActivityType = {
    ACTIVE_IN_PERIOD: 'ACTIVE_IN_PERIOD',
    INACTIVE_IN_PERIOD: 'INACTIVE_IN_PERIOD',
    NEVER_ACTIVE: 'NEVER_ACTIVE',
    TOTAL: 'TOTAL'
};

const fetchGasStationActivity = async (market, selectedGSZIds, dateRange) => {
    const response = await apiService.post(
        `${process.env.REACT_APP_SERVICE_URL}/api/dashboard/gas-station-activity`,
        {
            market,
            selectedGSZIds,
            dateRange
        }
    );
    return response.data;
};

export const useGasStationActivity = ({ market, selectedGSZIds, dateRange, enabled = true }) => {
    return useQuery({
        queryKey: ['gasStationActivity', market, selectedGSZIds, dateRange],
        queryFn: () => fetchGasStationActivity(market, selectedGSZIds, dateRange),
        enabled: enabled && selectedGSZIds && selectedGSZIds.length > 0,
        staleTime: 60 * 60 * 1000, // Consider data fresh for 60 minutes
        refetchOnWindowFocus: false // Disable automatic refetching when window regains focus
    });
};